export default "__VITE_ASSET__10649552__"